import Vue from 'vue';

import setting from './setting.vue';
Vue.component('mag-setting', setting);